import React from 'react';
import { Stack } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SECTION_CARD_BASE_CLASSES =
  'px-3 py-4 px-4 py-3 section-cont section-cont--rounded-2 section-cont--shadow';

const SectionCard: React.FC<
  React.PropsWithChildren<React.ComponentProps<typeof Stack>>
> = ({ children, className = '', ...props }) => {
  return (
    <Stack
      {...props}
      className={`${SECTION_CARD_BASE_CLASSES} justify-content-between ${className}`}
    >
      {children}
    </Stack>
  );
};

SectionCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

interface SectionCardButtonProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const SectionCardButton: React.FC<SectionCardButtonProps> = ({
  onClick,
  disabled = false,
  children,
  className = ''
}) => {
  return (
    <Button
      className={`${SECTION_CARD_BASE_CLASSES} btn btn--primary-light border-0 text-start w-100 d-flex justify-content-between ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

SectionCardButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default SectionCard;
